import { render } from "./app-store.vue?vue&type=template&id=65507ab9"
import script from "./app-store.vue?vue&type=script&lang=js"
export * from "./app-store.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__